"use client";
import { Size } from "@/api/AppApi/common-interfaces/api-enums";
import { DiscountTypes } from "@/api/AppApi/services/home/interfaces/IProduct";
import { useCurrencyCalc } from "@/hooks/useCurrencyCalc";
import SvgBadge from "./SvgBadge";
import { useTranslation } from "@/hooks/localization/useTranslations";
import { useGetCompanyQuery } from "@/api/AppApi/services/company";
interface Props {
  discount_amount: number;
  showNewBadge: boolean;
  size: Size;
  discount_type?: DiscountTypes;
  showDiscountBadge: boolean;
  isSaleLabel: boolean;
  discount?: number;
  outOfStock?: boolean;
  showSoldQuantityBadge: boolean;
  sold_quantity?: number;
}
const ProductBadge = ({
  discount_amount,
  size,
  showNewBadge,
  showDiscountBadge,
  discount_type,
  isSaleLabel,
  discount,
  outOfStock,
  showSoldQuantityBadge,
  sold_quantity,
}: Props) => {
  const t = useTranslation();
  const { data } = useGetCompanyQuery();
  const { currency, getPriceString } = useCurrencyCalc({
    enable: data?.result?.theme?.settings?.enable_currencies_converter ?? true,
  });
  let discountText = isSaleLabel
    ? t.sale
    : discount_type === DiscountTypes.fixed
    ? `-${getPriceString(discount_amount)} ${currency?.symbol}`
    : `-${discount}%`;

  const large = size === Size.large;
  return (
    <div
      className="m-0 d-flex flex-column"
      style={{
        width: "fit-content",
        position: "absolute",
        top: 8,
        alignItems: "top",
        left: 0,
      }}
    >
      {showNewBadge && (
        <div className="p-0">
          <SvgBadge text={t.new} large={large} />
        </div>
      )}
      {showSoldQuantityBadge && (
        <div className="p-0">
          <SvgBadge
            text={`${t.sold} ${sold_quantity} ${t.pcs}`}
            large={large}
          />
        </div>
      )}
      {showDiscountBadge && (
        <div className="p-0">
          <SvgBadge text={discountText} large={large} sale={isSaleLabel} />
        </div>
      )}
      {outOfStock && (
        <div className="p-0">
          <SvgBadge text={t.out_of_stock} large={large} sale={true} />
        </div>
      )}
    </div>
  );
};

export default ProductBadge;
